<template>
  <v-dialog width="500" v-model="showDaCompanychangeDialog">
    <v-card>
      <v-card-title class="secondary white--text">
        <span> Update Customer on DA </span>

        <v-spacer></v-spacer>
        <v-btn icon @click="showDaCompanychangeDialog = false">
          <v-icon class="white--text">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-2">
        <v-form v-if="showDaCompanychangeDialog" v-model="isValid">
          <v-row class="ma-0">
            <v-alert
    type="info"
    dense
    
    class="mb-2"
  >
    Changing the customer of this Delivery Advice will also update the customer for all related legs.
  </v-alert>
            <v-col cols="12" class="Form-Columns">
               <MultiSelect
            hide-details="auto"
            label="Select Customer Company"
            :items="allCustomerList"
            itemText="company_title"
            :rules="[(val) => !!val || 'Customer is Required!']"
            itemValue="id"
            v-model="formDetails.company"
          />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="justify-end">
        <v-btn
          color="primary"
          depressed
          :disabled="!isValid"
          @click="submitForm"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";

export default {
  components: {
    MultiSelect,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
   
   company: {
    type: [Number, String],
    default: null
  },
  id:{
    type: [Number, String],
      default: null
  }


    
  },
  computed: {
    showDaCompanychangeDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      module_type: null,
      allCustomerList:[],
      isValid: true,
      formErrors: {},
      formDetails: {},
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.getCustomerList()
        this.formDetails = {
        company: this.company,  
        id:this.id
      };
      } else {
      }
    },
  },
  methods: {

    getCustomerList(params = {}) {
      this.listLoading = true;
      params = {
        company_type: "Customer",
        offset: 0,
        is_active:true,
        limit: 10,
        ...params,
      };
      this.$api.company
        .getCompanySelectList(params)
        .then((res) => {
          this.listLoading = false;
          if ("count" in res) {
            this.customerCount = res.count;
          }

          if (params.offset == 0) {
            this.allCustomerList = res.data;
          } else {
            this.allCustomerList.push(...res.data);
          }
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    
    submitForm() {
      this.$bus.$emit("showLoader", true);
      let payload = {
        company: this.formDetails.company,
        id: this.formDetails.id
        
      };
     
      this.$api.deliveryAdvice
        .updateDACompany(payload)
        .then((res) => {
          this.showDaCompanychangeDialog = false;
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", {
            message: "Customer Updated Successfully!",
            color: "success",
          });
          this.formErrors = {};
          this.$emit("refreshList");
        })
        .catch((err) => {
          this.formErrors = {};
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", {
            message: "Couldn't update customer!",
            color: "error",
          });
        });
    },
  },
};
</script>
